<template>
  <div>
    <section>
      <div class="sku">
        <h1>Choose Your Products!</h1>
        <h2>Here are some of the products you can offer to your fans!</h2>
        <div class="sku-details">
          <div>
            <p><span style="margin-right: 1rem">👀</span>Exclusive Content</p>
            <p><span style="margin-right: 1rem">🗣</span>Fan Shoutouts</p>
            <p><span style="margin-right: 1rem">🏋🏻</span>Challenges</p>
            <p><span style="margin-right: 1rem">💟</span>Subscription Group</p>
            <p><span style="margin-right: 1rem">🤝</span>Meet and Greet</p>
          </div>
          <div>
            <p><span style="margin-right: 1rem">❓</span>Ask Me Anything</p>
            <p><span style="margin-right: 1rem">🛍️</span>Merchandise</p>
            <p><span style="margin-right: 1rem">🤲🏻</span>Tip Jar</p>
            <p><span style="margin-right: 1rem">♻️</span>Fan Subscriptions</p>
            <p><span style="margin-right: 1rem">🤳🏻</span>Livestream</p>
          </div>
          <div>
            <p><span style="margin-right: 1rem">🎁</span>Gift Box</p>
            <p><span style="margin-right: 1rem">💌</span>Newsletter</p>
            <p><span style="margin-right: 1rem">👗</span>Pre-loved Items</p>
            <p><span style="margin-right: 1rem">🎟️</span>Concert Tickets</p>
            <p><span style="margin-right: 1rem">🌎</span>Fundraiser</p>
          </div>
        </div>
        <h2
          class="visit"
          onclick="window.open('https://productcatalogue.helixpay.ph')"
        >
          Visit our product catalogue
        </h2>
      </div>
    </section>
  </div>
</template>

<style scoped>
section {
  width: 100%;
  padding: 3rem 2rem;
  text-align: center;

  background-image: url('/img/sku-wallpaper.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.sku {
  max-width: 60rem;
  margin: auto;
  text-align: center;
  padding: 3rem 0 0 0;
}

.sku h1 {
  margin-bottom: 1rem;
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  color: black;
}

.sku > h2 {
  max-width: 40rem;
  margin: auto;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 2rem;
}

.sku-details {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  text-align: left;
}

.sku-details div {
  display: grid;
  font-size: 1rem;
  font-weight: 600;
  padding: 2rem;
  padding-top: 3rem;
  border-radius: 5px;
  justify-content: center;
  background-color: white;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.sku .visit {
  color: white;
  width: fit-content;
  font-weight: 600;
  border-radius: 5px;
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: #ff5f8f;
  cursor: pointer;
  text-transform: uppercase;
  transition: 0.2s ease-in;
}

.visit:hover {
  transform: translateY(-7px);
  background-color: #eb4c7b;
}

@media only screen and (max-width: 1000px) {
  .sku-details {
    grid-template-columns: 1fr;
  }

  .sku {
    max-width: 30rem;
  }
}

@media only screen and (max-width: 800px) {
  .sku h1 {
    text-align: center;
    font-size: 1.5rem;
  }

  .sku-details div p {
    font-size: 1rem;
  }
}
</style>
